export default "__VITE_ASSET__BNR14HQV__"